import * as ambassadorWixPremiumResellerV1Packages from './premium-reseller-v1-packages-packages.http.js';
import * as ambassadorWixPremiumResellerV1PackagesTypes from './premium-reseller-v1-packages-packages.types.js';
import * as ambassadorWixPremiumResellerV1PackagesUniversalTypes from './premium-reseller-v1-packages-packages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPackage(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CreatePackageRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.CreatePackageRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CreatePackageResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.CreatePackageResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.createPackage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/packages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createPackageV2(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CreatePackageRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.CreatePackageRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CreatePackageResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.CreatePackageResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.createPackageV2(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/packages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelPackage(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CancelPackageRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.CancelPackageRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CancelPackageResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.CancelPackageResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.cancelPackage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/packages/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPackage(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.GetPackageRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.GetPackageRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.GetPackageResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.GetPackageResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.getPackage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/packages/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPackages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.QueryPackagesRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.QueryPackagesRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.QueryPackagesResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.QueryPackagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.queryPackages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/packages/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function assignProductInstanceToSite(): __PublicMethodMetaInfo<
  'PATCH',
  { instanceId: string; siteId: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.AssignProductInstanceToSiteRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.AssignProductInstanceToSiteRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.AssignProductInstanceToSiteResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.AssignProductInstanceToSiteResponse
> {
  const payload = { instanceId: ':instanceId', siteId: ':siteId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.assignProductInstanceToSite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/packages/product-instances/{instanceId}/{siteId}',
    pathParams: { instanceId: 'instanceId', siteId: 'siteId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unassignProductInstanceFromSite(): __PublicMethodMetaInfo<
  'PATCH',
  { instanceId: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.UnassignProductInstanceFromSiteRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.UnassignProductInstanceFromSiteRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.UnassignProductInstanceFromSiteResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.UnassignProductInstanceFromSiteResponse
> {
  const payload = { instanceId: ':instanceId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.unassignProductInstanceFromSite(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/packages/product-instances/{instanceId}/unassign',
    pathParams: { instanceId: 'instanceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelProductInstance(): __PublicMethodMetaInfo<
  'DELETE',
  { instanceId: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CancelProductInstanceRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.CancelProductInstanceRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.CancelProductInstanceResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.CancelProductInstanceResponse
> {
  const payload = { instanceId: ':instanceId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.cancelProductInstance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/packages/product-instances/{instanceId}',
    pathParams: { instanceId: 'instanceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function adjustProductInstanceSpecifications(): __PublicMethodMetaInfo<
  'PATCH',
  { instanceId: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.AdjustProductInstanceSpecificationsRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.AdjustProductInstanceSpecificationsRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.AdjustProductInstanceSpecificationsResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.AdjustProductInstanceSpecificationsResponse
> {
  const payload = { instanceId: ':instanceId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.adjustProductInstanceSpecifications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/packages/product-instances/{instanceId}',
    pathParams: { instanceId: 'instanceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePackageExternalId(): __PublicMethodMetaInfo<
  'PATCH',
  { packageId: string; externalId: string },
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.UpdatePackageExternalIdRequest,
  ambassadorWixPremiumResellerV1PackagesTypes.UpdatePackageExternalIdRequest,
  ambassadorWixPremiumResellerV1PackagesUniversalTypes.UpdatePackageExternalIdResponse,
  ambassadorWixPremiumResellerV1PackagesTypes.UpdatePackageExternalIdResponse
> {
  const payload = { packageId: ':packageId', externalId: ':externalId' } as any;

  const getRequestOptions =
    ambassadorWixPremiumResellerV1Packages.updatePackageExternalId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/packages/update/{packageId}/{externalId}',
    pathParams: { packageId: 'packageId', externalId: 'externalId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Package as PackageOriginal,
  ProductInstance as ProductInstanceOriginal,
  ProductInstanceContractDetailsOneOf as ProductInstanceContractDetailsOneOfOriginal,
  FailureReasonCode as FailureReasonCodeOriginal,
  FailureReasonCodeWithLiterals as FailureReasonCodeWithLiteralsOriginal,
  IntervalIntervalUnit as IntervalIntervalUnitOriginal,
  IntervalIntervalUnitWithLiterals as IntervalIntervalUnitWithLiteralsOriginal,
  CycleDescriptorType as CycleDescriptorTypeOriginal,
  CycleDescriptorTypeWithLiterals as CycleDescriptorTypeWithLiteralsOriginal,
  CycleInterval as CycleIntervalOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  FailureReason as FailureReasonOriginal,
  ProductInstanceCycle as ProductInstanceCycleOriginal,
  CreatePackageRequest as CreatePackageRequestOriginal,
  CreatePackageResponse as CreatePackageResponseOriginal,
  CancelPackageRequest as CancelPackageRequestOriginal,
  CancelPackageResponse as CancelPackageResponseOriginal,
  PackageCanceled as PackageCanceledOriginal,
  GetPackageRequest as GetPackageRequestOriginal,
  GetPackageResponse as GetPackageResponseOriginal,
  QueryPackagesRequest as QueryPackagesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPackagesResponse as QueryPackagesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  AssignProductInstanceToSiteRequest as AssignProductInstanceToSiteRequestOriginal,
  AssignProductInstanceToSiteResponse as AssignProductInstanceToSiteResponseOriginal,
  AssignedProductInstanceToSite as AssignedProductInstanceToSiteOriginal,
  UnassignProductInstanceFromSiteRequest as UnassignProductInstanceFromSiteRequestOriginal,
  UnassignProductInstanceFromSiteResponse as UnassignProductInstanceFromSiteResponseOriginal,
  UnassignedProductInstanceFromSite as UnassignedProductInstanceFromSiteOriginal,
  CancelProductInstanceRequest as CancelProductInstanceRequestOriginal,
  CancelProductInstanceResponse as CancelProductInstanceResponseOriginal,
  ProductInstanceCanceled as ProductInstanceCanceledOriginal,
  AdjustProductInstanceSpecificationsRequest as AdjustProductInstanceSpecificationsRequestOriginal,
  AdjustProductInstanceSpecificationsResponse as AdjustProductInstanceSpecificationsResponseOriginal,
  AdjustedProductInstanceSpecifications as AdjustedProductInstanceSpecificationsOriginal,
  SubscriptionEvent as SubscriptionEventOriginal,
  SubscriptionEventEventOneOf as SubscriptionEventEventOneOfOriginal,
  SubscriptionCreated as SubscriptionCreatedOriginal,
  Subscription as SubscriptionOriginal,
  BillingReference as BillingReferenceOriginal,
  ProviderName as ProviderNameOriginal,
  ProviderNameWithLiterals as ProviderNameWithLiteralsOriginal,
  Cycle as CycleOriginal,
  CycleCycleSelectorOneOf as CycleCycleSelectorOneOfOriginal,
  Interval as IntervalOriginal,
  IntervalUnit as IntervalUnitOriginal,
  IntervalUnitWithLiterals as IntervalUnitWithLiteralsOriginal,
  OneTime as OneTimeOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  ReactivationData as ReactivationDataOriginal,
  ReactivationReasonEnum as ReactivationReasonEnumOriginal,
  ReactivationReasonEnumWithLiterals as ReactivationReasonEnumWithLiteralsOriginal,
  SubscriptionAssigned as SubscriptionAssignedOriginal,
  SubscriptionCancelled as SubscriptionCancelledOriginal,
  CancellationDetails as CancellationDetailsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  RefundType as RefundTypeOriginal,
  RefundTypeWithLiterals as RefundTypeWithLiteralsOriginal,
  SubscriptionAutoRenewTurnedOn as SubscriptionAutoRenewTurnedOnOriginal,
  SubscriptionAutoRenewTurnedOff as SubscriptionAutoRenewTurnedOffOriginal,
  SubscriptionUnassigned as SubscriptionUnassignedOriginal,
  UnassignReason as UnassignReasonOriginal,
  UnassignReasonWithLiterals as UnassignReasonWithLiteralsOriginal,
  SubscriptionTransferred as SubscriptionTransferredOriginal,
  RecurringChargeSucceeded as RecurringChargeSucceededOriginal,
  ContractSwitched as ContractSwitchedOriginal,
  ContractSwitchType as ContractSwitchTypeOriginal,
  ContractSwitchTypeWithLiterals as ContractSwitchTypeWithLiteralsOriginal,
  ContractSwitchReason as ContractSwitchReasonOriginal,
  ContractSwitchReasonWithLiterals as ContractSwitchReasonWithLiteralsOriginal,
  ProductPriceIncreaseData as ProductPriceIncreaseDataOriginal,
  PriceIncreaseTrigger as PriceIncreaseTriggerOriginal,
  PriceIncreaseTriggerWithLiterals as PriceIncreaseTriggerWithLiteralsOriginal,
  ProductAdjustment as ProductAdjustmentOriginal,
  ProductAdjustmentWithLiterals as ProductAdjustmentWithLiteralsOriginal,
  SubscriptionNearEndOfPeriod as SubscriptionNearEndOfPeriodOriginal,
  SubscriptionPendingChange as SubscriptionPendingChangeOriginal,
  RecurringChargeAttemptFailed as RecurringChargeAttemptFailedOriginal,
  Empty as EmptyOriginal,
  ProductInstanceUpdated as ProductInstanceUpdatedOriginal,
  FailureReportRequest as FailureReportRequestOriginal,
  ProductInstanceFailed as ProductInstanceFailedOriginal,
  UpdateProductInstanceRequest as UpdateProductInstanceRequestOriginal,
  FieldToUpdate as FieldToUpdateOriginal,
  FieldToUpdateWithLiterals as FieldToUpdateWithLiteralsOriginal,
  UpdateProductInstanceResponse as UpdateProductInstanceResponseOriginal,
  UpdatePackageExternalIdRequest as UpdatePackageExternalIdRequestOriginal,
  UpdatePackageExternalIdResponse as UpdatePackageExternalIdResponseOriginal,
  CountPackagesRequest as CountPackagesRequestOriginal,
  CountPackagesResponse as CountPackagesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  MigrateSubscriptionToPackagesRequest as MigrateSubscriptionToPackagesRequestOriginal,
  MigrateSubscriptionToPackagesResponse as MigrateSubscriptionToPackagesResponseOriginal,
  FixBrokenMigrationRequest as FixBrokenMigrationRequestOriginal,
  FixBrokenMigrationResponse as FixBrokenMigrationResponseOriginal,
} from './premium-reseller-v1-packages-packages.types.js';
